module.exports = __webpack_public_path__ + "img/crystals-min.ac173cca.jpg";